import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools';

import { useDataRetentionDetailsGetDetailsQuery } from '../hooks/useDataRetentionDetails';

interface PreloadDataRetentionQueryI {
	cloudId: string;
}

export const preloadDataRetentionPolicy = async ({ cloudId }: PreloadDataRetentionQueryI) => {
	if (!cloudId || !fg('dlp-dlm-data-retention-policy')) {
		return;
	}

	return query({
		query: useDataRetentionDetailsGetDetailsQuery,
		variables: { cloudId },
		errorPolicy: 'all',
	});
};
